export default function RightSide({ options }) {
  return (
    <div className="dp-top-options">
      {options.map((option, index) => {
        return (
          <a key={index} href={option.href} className="option">
            <i className={option.icon} />
            <span>{option.title}</span>
          </a>
        );
      })}
    </div>
  );
}
